import { Paper, styled } from '@mui/material';

import AccountingIllustration from 'assets/img/business-setup-cards/accounting.png';

// Figma frame geometry: the illustration layer is 562px tall in a 694px panel, centred vertically with
// its midpoint 46% of the way across. Sized off the panel's height so the framing holds at any height.
const ILLUSTRATION_HEIGHT = `${(562 / 694) * 100}%`;
const ILLUSTRATION_CENTER_X = `${(316.5 / 688) * 100}%`;

/**
 * SplitPanelLayout slot props for a wizard step with this panel on the right: fills the content area
 * without scrolling, with Figma's 32px right and bottom gutter.
 */
export const ILLUSTRATION_LAYOUT_SLOT_PROPS = {
    stack: { sx: { height: '100%' } },
    grid: { right: { sx: { p: { xs: 2, md: 0 }, pr: { md: 4 }, pb: { md: 4 } } } },
};

const IllustrationPanel = styled(Paper)(({ theme }) => ({
    position: 'relative',
    borderRadius: theme.spacing(2.5),
}));

const Illustration = styled('img')({
    position: 'absolute',
    top: '50%',
    left: ILLUSTRATION_CENTER_X,
    height: ILLUSTRATION_HEIGHT,
    width: 'auto',
    maxWidth: 'none',
    transform: 'translate(-50%, -50%)',
    // The asset is cropped through its shadow; fading the bottom edge hides the hard line.
    maskImage: 'linear-gradient(to bottom, #000 92%, transparent 100%)',
});

export default function AccountingIllustrationPanel() {
    return (
        <IllustrationPanel
            variant="filled"
            sx={{
                width: '100%',
                height: '100%',
                display: { xs: 'none', md: 'block' },
                overflow: 'hidden',
            }}>
            <Illustration src={AccountingIllustration} alt="" />
        </IllustrationPanel>
    );
}
